import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, MenuItem, Select, Typography, useTheme } from "@mui/material";
import { useState } from "react";
import { modifyNotificationGroups, saveNotificationGroups } from "../../../api/s10OrganizationApi";
import { ModifyNotificationGroup } from "../../../interfaces/auth.interface";
import MyTextField from "../../../components/MyTextField";
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';



interface CreateApprovalGroupModalProps {
    notificationGroupToEdit?: ModifyNotificationGroup;
    companyId: string;
    handleCloseModal: ({success, msg}: {success?: boolean, msg?: string}) => void;
}

const CreateApprovalGroupModal = ({handleCloseModal, companyId, notificationGroupToEdit}: CreateApprovalGroupModalProps) => {

    const theme = useTheme();
    const [loading, setLoading] = useState<boolean>(false);
    const [type, setType] = useState<string>(notificationGroupToEdit?.Type 
            ? String(notificationGroupToEdit?.Type) 
            : "1"
    );
    const [name, setName] = useState<string>(notificationGroupToEdit?.Name || "");

    const handleModifyAppovalGroup = async () => {
        setLoading(true);
        const {data} = await modifyNotificationGroups({
            Id: notificationGroupToEdit?.Id as any,
            Name: name,
            Type: Number(type),
            CompanyCode: companyId,
        } as any);
        console.log({
            Id: notificationGroupToEdit?.Id as any,
            Name: name,
            Type: Number(type),
        });
        console.log(data)
        const msg = data?.Type === 0
            ? 'Grupo actualizado con éxito.'
            : 'Error actualizando el grupo';
        setLoading(false);
        handleCloseModal({
            success: data?.Type === 0,
            msg,
        });

    }

    const handleSaveAppovalGroup = async () => {
        setLoading(true);
        const {data} = await saveNotificationGroups({
            Name: name,
            Type: Number(type),
            CompanyCode: companyId,
        });
        console.log(data)
        const msg = data?.Type === 0
            ? 'Grupo creado con éxito.'
            : data?.Message || 'Error creando el grupo';
        setLoading(false);
        handleCloseModal({
            success: data?.Type === 0,
            msg,
        });

    }

    const handleSaveAction = async () => {
        if (loading) {
            return;
        }
        if (notificationGroupToEdit?.Id !== undefined) {
            await handleModifyAppovalGroup();
        } else {
            await handleSaveAppovalGroup();
        }
    }

    return (

        <Dialog
            open={true}
            aria-labelledby="responsive-dialog-title"
            style={{width: "100%"}}
        >
            <DialogTitle 
                id="responsive-dialog-title" 
                style={{padding: "0", margin: "2rem 0 1rem 0", textAlign: "center"}} 
                variant="h5"
            >
                Grupo de aprobación
            </DialogTitle>
            <DialogContent style={{width: "100%", textAlign: "center"}}>
                <Grid container spacing="1.5rem">
                    <Grid item xs={12}>
                        <MyTextField 
                            style={{width: "100%"}} 
                            label="Nombre"
                            onChange={({target}) => setName(target.value)}
                            value={name}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Typography 
                            // variant="caption"
                            align='left'
                            style={{
                                color: theme.s10palette.S10Greygrey700,
                                fontSize: "1rem",
                                fontStyle: "normal",
                                fontWeight: 400,
                                lineHeight: "1.25",
                        }}
                        >
                            Tipo de grupo
                        </Typography>
                        <Select
                            labelId="select-option-label"
                            id="select-option"
                            // label={"Grupo de notificación"}
                            onChange={(event: { target: { value: string } }) => {
                                const value = event.target.value;
                                setType(String(value));
                            }}
                            value={type}
                            style={{height: "2.5rem", border: "none", backgroundColor: "white", textAlign: "left"}}
                        >
                            <MenuItem
                                value={"0"}
                            >
                                Ausencias
                            </MenuItem>
                            <MenuItem
                                value={"1"}
                            >
                                Contratos
                            </MenuItem>
                        </Select>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Grid container margin={"0.5rem 1.5rem 2rem 1.5rem"}>
                    <Grid item xs={6}>
                        <Button 
                            variant="outlined" 
                            style={{width: "8rem"}}
                            startIcon={<CloseIcon style={{height: "1rem"}} />}
                            onClick={() => handleCloseModal({})}
                        >
                            Cancelar
                        </Button>
                    </Grid>
                    <Grid item xs={6} textAlign={"right"}>
                        <Button 
                            variant="contained" 
                            style={{width: "8rem"}}
                            startIcon={<CheckIcon style={{height: "1rem"}} />}
                            disabled={!type || !name}
                            onClick={handleSaveAction}
                        >
                            Aceptar
                        </Button>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>
    )
}

export default CreateApprovalGroupModal;